import {Flex} from 'antd';
import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import ArrowUpRight from '../../../assets/ArrowUpRight.png';
import BlackCrown from '../../../assets/BlackCrown.png';
import dataIcon from '../../../assets/Data.png';
import GlobeIcon from '../../../assets/Globe.png';
import LeafIcon from '../../../assets/Leaf.png';
import MyOrg from '../../../assets/MyOrg.png';
import OrgFacility from '../../../assets/OrgFacility.png';
// import TrangleIcon from '../../../assets/Triangle.png';
import UserGroup from '../../../assets/Users_Group.png';
import {allRoutes, Routes} from '../../../constants/Routes';
import {
  accessModule,
  countModule
} from '../../../store/companyStore/companyDetailsStore';
import {removeSlash} from '../../../utils/removeSlash';
import {
  hasMaxLimitReached,
  shouldBlockModuleAccess,
  isOnboardingDone,
  shouldBlockReadOnly,
  shouldBlockFreeOrReadOnly
} from '../../../utils/SubscriptionHelper';

import HeaderTitle from './HeaderTitle';

interface BusinessItem {
  id: number;
  title: string;
  logo: string;
  route: string;
  isBlock: boolean;
}

const MyOrganization: React.FC<{
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
}> = ({setOpenKeys}) => {
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const [data, setData] = useState<BusinessItem[]>([
    {
      id: 1,
      title: 'About the Company',
      logo: OrgFacility,
      route: `${allRoutes.Configurator.org_facility}`,
      isBlock: shouldBlockReadOnly()
    },
    {
      id: 2,
      title: 'Manage Value Chain',
      logo: LeafIcon,
      route: `${allRoutes.Configurator.valueChainMng}`,
      isBlock: shouldBlockFreeOrReadOnly()
    },
    {
      id: 3,
      title: 'Manage Databases',
      logo: dataIcon,
      route: `${allRoutes.Configurator.data_management}`,
      isBlock: shouldBlockReadOnly()
    },
    {
      id: 4,
      title: 'Manage Users',
      logo: UserGroup,
      route: `${allRoutes.Configurator.user_management}`,
      isBlock:
        ((hasMaxLimitReached(countModule.externalStakeholders) ||
          shouldBlockModuleAccess(accessModule.externalStakeholders)) &&
          hasMaxLimitReached(countModule.internalUsers)) ||
        shouldBlockReadOnly()
    },
    {
      id: 5,
      title: 'Organization Hierarchy',
      logo: GlobeIcon,
      route: `${allRoutes.Configurator.org_and_process_flow}`,
      isBlock: shouldBlockReadOnly()
    }
    // {
    //   id: 6,
    //   title: 'Process Flow',
    //   logo: TrangleIcon,
    //   route: `${allRoutes.Configurator.process_flow}`,
    //   isBlock:
    //     shouldBlockModuleAccess(accessModule.processFlow) ||
    //     shouldBlockReadOnly()
    // }
  ]);

  useEffect(() => {
    setData((prev) => [...prev]);
  }, []);

  const configuratorRoute = removeSlash(Routes.CONFIGURATOR);

  return (
    <div className="getStartedContainer">
      <HeaderTitle
        headText={'My Organization'}
        subText={'Setup your organizational data'}
        hasOption={false}
        scrollNext={undefined}
        scrollPrev={undefined}
      />
      <div className="myOrgContainer">
        <div style={{background: '#E1F1D9', borderRadius: '16px 16px 0 0'}}>
          <img
            src={MyOrg}
            width={'100%'}
            height="200px"
            style={{borderTopLeftRadius: '16px', borderTopRightRadius: '16px'}}
          />
        </div>
        <div className="features-container">
          {data.map((feature) => (
            <Flex
              key={feature.id}
              className="feature-card"
              justify="space-between"
            >
              {feature.isBlock ? (
                <div
                  className={
                    hoveredId === feature.id
                      ? 'icon-circle-hover'
                      : 'icon-circle'
                  }
                  onClick={() => {
                    navigate(Routes.PRICING_DETAILS);
                  }}
                  onMouseEnter={() => {
                    setHoveredId(feature.id);
                  }}
                  onMouseLeave={() => {
                    setHoveredId(null);
                  }}
                >
                  <img
                    src={hoveredId === feature.id ? BlackCrown : feature.logo}
                    width={40}
                    height={40}
                    alt="check"
                  />
                </div>
              ) : (
                <div
                  className="icon-circle"
                  onMouseEnter={() => {
                    setHoveredId(feature.id);
                  }}
                  onMouseLeave={() => {
                    setHoveredId(null);
                  }}
                  onClick={() => {
                    if (isOnboardingDone()) {
                      navigate(feature?.route);
                      setOpenKeys(
                        configuratorRoute
                          ? Array.isArray(configuratorRoute)
                            ? configuratorRoute
                            : [configuratorRoute]
                          : []
                      );
                    }
                  }}
                >
                  <img
                    src={hoveredId === feature.id ? ArrowUpRight : feature.logo}
                    width={'100%'}
                    height={'100%'}
                    alt="check"
                  />
                </div>
              )}
              <p className="feature-text">{feature.title}</p>
            </Flex>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyOrganization;
